import React, { useState, useEffect } from 'react';
import '../AdminManager.css';

function CategoryManager() {
  const [categories, setCategories] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    nameEn: '',
    icon: '💻',
    description: '',
    order: 0,
    isActive: true,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/categories/all', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      const url = editingCategory
        ? `/api/categories/${editingCategory.id}`
        : '/api/categories';
      const method = editingCategory ? 'PUT' : 'POST';

      const data = new FormData();
      data.append('name', formData.name);
      data.append('nameEn', formData.nameEn);
      data.append('icon', formData.icon);
      data.append('description', formData.description);
      data.append('order', formData.order);
      data.append('isActive', formData.isActive);
      if (selectedFile) {
        data.append('image', selectedFile);
      }

      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      });

      if (response.ok) {
        fetchCategories();
        resetForm();
      }
    } catch (error) {
      console.error('Error saving category:', error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Είστε σίγουροι;')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/categories/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        fetchCategories();
      }
    } catch (error) {
      console.error('Error deleting category:', error);
    }
  };

  const handleEdit = (category) => {
    setEditingCategory(category);
    setFormData({
      name: category.name,
      nameEn: category.nameEn,
      icon: category.icon,
      description: category.description || '',
      order: category.order,
      isActive: category.isActive
    });
    setPreviewUrl(category.image || null);
    setSelectedFile(null);
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData({
      name: '',
      nameEn: '',
      icon: '💻',
      description: '',
      order: 0,
      isActive: true,
    });
    setEditingCategory(null);
    setSelectedFile(null);
    setPreviewUrl(null);
    setShowForm(false);
  };

  return (
    <div className="manager-container">
      <div className="manager-header">
        <h1 className="page-title">Κατηγορίες</h1>
        <button
          className="btn btn-primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Ακύρωση' : '+ Νέα Κατηγορία'}
        </button>
      </div>

      {showForm && (
        <div className="form-card">
          <h2>{editingCategory ? 'Επεξεργασία Κατηγορίας' : 'Νέα Κατηγορία'}</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Όνομα (Ελληνικά) *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Όνομα (Αγγλικά) *</label>
                <input
                  type="text"
                  value={formData.nameEn}
                  onChange={(e) => setFormData({ ...formData, nameEn: e.target.value })}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Εικόνα Κατηγορίας</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileSelect}
                className="file-input"
              />
              {previewUrl && (
                <div className="image-preview">
                  <img src={previewUrl} alt="Preview" style={{ maxHeight: '100px', marginTop: '10px' }} />
                </div>
              )}
            </div>

            <div className="form-group">
              <label>Icon (Emoji - Εναλλακτικά)</label>
              <input
                type="text"
                value={formData.icon}
                onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                placeholder="💻"
              />
            </div>

            <div className="form-group">
              <label>Περιγραφή</label>
              <textarea
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows="3"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Σειρά</label>
                <input
                  type="number"
                  value={formData.order}
                  onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
                />
              </div>
              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                  />
                  Ενεργό
                </label>
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingCategory ? 'Ενημέρωση' : 'Δημιουργία'}
              </button>
              <button type="button" className="btn btn-outline" onClick={resetForm}>
                Ακύρωση
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="items-grid">
        {categories.map((category) => (
          <div key={category.id} className="grid-item-card">
            <div className="grid-item-icon">
              {category.image ? (
                <img src={category.image} alt={category.name} style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '8px' }} />
              ) : (
                category.icon
              )}
            </div>
            <h3>{category.name}</h3>
            <p className="grid-item-subtitle">{category.nameEn}</p>
            <p className="grid-item-description">{category.description}</p>
            <div className="item-meta">
              <span className={`status-badge ${category.isActive ? 'active' : 'inactive'}`}>
                {category.isActive ? 'Ενεργό' : 'Ανενεργό'}
              </span>
            </div>
            <div className="item-actions">
              <button className="btn-icon" onClick={() => handleEdit(category)}>
                ✏️
              </button>
              <button className="btn-icon" onClick={() => handleDelete(category.id)}>
                🗑️
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CategoryManager;
